module.exports = __webpack_public_path__ + "assets/img/activity-bottom-btn.6ce68e98.png";